import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import PropTypes from 'prop-types';
import * as selector from '../state/selector';
import * as operation from '../state/operation';

export const MachineVncCheckOneAlreadyRunModal = ({ idParam }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.MACHINE_DETAILS);
  const dispatch = useDispatch();

  const { machineVncSession } = useSelector((state) => ({
    machineVncSession: selector.selectMachineVncSession(state)
  }));

  /**
   * @context pop up message to let user know that there is a VNC session running
   * @description Handle action to close warning message about already one vnc is running
   */
  const handleHideMachineVncCheckOneAlreadyRunModal = () => {
    dispatch(operation.hideMachineVncCheckOneAlreadyRunModal());
  };

  /**
   * @context pop up message to let user know that there is a VNC session running
   * @description Handle action to close current vnc session and open new vnc session with new machine
   */
  const handleAccessMachineVncCheckOneAlreadyRunModal = () => {
    dispatch(operation.hideMachineVncCheckOneAlreadyRunModal());
    dispatch(operation.resetMachineVncSession());
    dispatch(operation.resetMachineVncSessionStatus());
    dispatch(operation.activeExpand());
    dispatch(operation.requestMachineVncSession(idParam));
    localStorage.setItem(`current-machine-session`, idParam);
  };

  return (
    <Modal
      title={t('machineVncCheckOneAlreadyRunModal.title')}
      open={machineVncSession.modal.oneAlreadyRun.visible}
      className="base-modal no-select"
      closable={false}
      width={550}
      destroyOnClose
      footer={[
        <Row>
          <Col span={12}>
            <Button
              size="s"
              className="cancel-btn"
              onClick={handleHideMachineVncCheckOneAlreadyRunModal}>
              {t('machineVncCheckOneAlreadyRunModal.backButton')}
            </Button>
          </Col>
          <Col span={12}>
            <Button
              size="s"
              className="submit-btn base-yellow-btn"
              onClick={handleAccessMachineVncCheckOneAlreadyRunModal}>
              {t('machineVncCheckOneAlreadyRunModal.accessButton')}
            </Button>
          </Col>
        </Row>
      ]}>
      <pre className="machine-vnc-warning-already-running-session-message-modal whitespace-normal">
        {t('machineVncCheckOneAlreadyRunModal.description')}
      </pre>
    </Modal>
  );
};

MachineVncCheckOneAlreadyRunModal.propTypes = {
  idParam: PropTypes.string.isRequired
};
